import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const loadView = (view) => () => import(`../views/${view}.vue`)

const routes = [
  {
    path: '/',
    name: 'home',
    component: loadView('HomeView')
  },
  {
    path: '/about',
    name: 'about',
    component: loadView('AboutView')
  },
  {
    path: '/map',
    name: 'map',
    component: loadView('MapView')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
